import {
	summitTypeTurn as turn,
	summitTypeWinter as winter,
	factoryHalfRoundedDown,
	factoryHalfRoundedUp,
} from '@lc/const/modifiers';
import { createCardSummit } from '@lc/interface/card/summit/factory';

export const SummitMeta = [
	createCardSummit(0, `RECHARGE ALL OF YOUR BATTERIES`, turn),
	createCardSummit(
		1,
		`BUY A FACTORY FOR HALF (½) ITS COST, ROUNDED DOWN`,
		turn,
		factoryHalfRoundedDown
	),
	createCardSummit(2, `GET ONE (1) FREE CHARGED BATTERY`, turn),
	createCardSummit(
		3,
		`BUY A FACTORY FOR HALF (½) ITS COST, ROUNDED UP`,
		turn,
		factoryHalfRoundedUp
	),
	createCardSummit(
		4,
		`+2 AT WINTER SUMMIT FOR EACH CONTRACT IN YOUR NEIGHBORS’ FAIL PILES`,
		winter
	),
	createCardSummit(
		5,
		`+2 AT WINTER SUMMIT FOR EACH CONTRACT IN YOUR NEIGHBORS’ FAIL PILES`,
		winter
	),
	createCardSummit(
		6,
		`STEAL A BATTERY (CHARGED OR UNCHARGED) FROM A NEIGHBOR WHO HAS LOWER PR OR A HIGHER CARBON FOOTPRINT IF THE NEIGHBOR HAS BOTH LOWER PR AND A HIGHER FOOTPRINT, YOU MAY STEAL A FACTORY INSTEAD`,
		turn
	),
	createCardSummit(
		7,
		`ELIMINATE ANOTHER PLAYER FROM COMPETING IN AN AWARD`,
		turn
	),
	createCardSummit(
		8,
		`INCREASE YOUR HAND SIZE BY (2) FOR THE REST OF THE GAME YOU MAY DRAW TWO (2) CARDS WHEN YOU PLAY THIS`,
		turn
	),
	createCardSummit(
		9,
		`+1 ENERGY AT WINTER SUMMIT FOR EACH CARD IN YOUR HAND`,
		winter
	),
	createCardSummit(
		10,
		`IF YOU HAVE NO FAILED CONTRACTS AT WINTER SUMMIT: +2 ENERGY AT WINTER SUMMIT PER CONTRACT IN YOUR COMPLETED PILE`,
		winter
	),
	createCardSummit(
		11,
		`IF YOU HAVE THE HIGHEST PR AT THE WINTER SUMMIT: +8 ENERGY AT WINTER SUMMIT +4 IF TIED`,
		winter
	),
	createCardSummit(
		12,
		`IF YOU HAVE THE HIGHEST PR AT THE WINTER SUMMIT: +8 ENERGY AT WINTER SUMMIT +4 IF TIED`,
		winter
	),
	createCardSummit(
		13,
		`+2 ENERGY AT WINTER SUMMIT PER PIECE OF EQUIPMENT YOU OWN`,
		winter
	),
	createCardSummit(
		14,
		`IF YOU HAVE THE LOWEST CARBON FOOTPRINT: +1 ENERGY AT WINTER SUMMIT PER CARBON IN THE LARGEST FOOTPRINT`,
		winter
	),
	createCardSummit(
		15,
		`+3 ENERGY AT WINTER SUMMIT FOR EACH PREVIOUS SUMMIT WHERE YOU CONTRIBUTED THE MOST +1 FOR EACH TIE`,
		winter
	),
	createCardSummit(
		16,
		`IF YOU HAVE THE MOST FACTORIES AT THE WINTER SUMMIT: +5 ENERGY AT WINTER SUMMIT +2 IF TIED`,
		winter
	),
	createCardSummit(
		17,
		`IF YOU HAVE THE SMALLEST NUMBER OF BATTERIES AT THE WINTER SUMMIT: +1 ENERGY FOR EACH BATTERY A NEIGHBOR OF YOUR CHOICE HAS`,
		winter
	),
	createCardSummit(
		18,
		`IF YOU HAVE AT LEAST THREE (3) CONTRACTS IN YOUR COMPLETED PILE: +5 ENERGY AT WINTER SUMMIT`,
		winter
	),
	createCardSummit(
		19,
		`IF YOU HAVE THE MOST NUMBER OF BATTERIES AT WINTER SUMMIT: +5 ENERGY AT WINTER SUMMIT +2 IF TIED`,
		winter
	),
];
